// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__oDr8M","obliqueLineWrap":"membershipbadge_obliqueLineWrap__hHWP5","obliqueLine":"membershipbadge_obliqueLine__2OUr7"};